import { useState } from 'react';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import { useLanguage } from '../i18n';

const CONTACT_EMAIL = 'contact@nuclearteam.com';
const TIKTOK_URL = 'https://www.tiktok.com/@nuclear.team1';

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const { language } = useLanguage();
  const c = language === 'es' ? { title:'Creemos algo jugable juntos', intro:'¿Tenés un proyecto en mente, dudas o ganas de hablar de videojuegos? Escribinos.', email:'Correo', copy:'Copiar', copied:'Copiado', send:'Enviar correo', copyLabel:'Copiar correo' } : { title:"Let's make something playable together", intro:'Have a project in mind, questions, or simply want to talk about games? Write to us.', email:'Email', copy:'Copy', copied:'Copied', send:'Send email', copyLabel:'Copy email' };

  const handleCopyEmail = async () => {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
    } else {
      const input = document.createElement('textarea');
      input.value = CONTACT_EMAIL;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }

    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section id="contact" className="section-shell min-h-screen flex items-center justify-center px-4 py-12 sm:py-16 lg:py-20">
      <div className="section-content max-w-4xl mx-auto text-center w-full">
        <h2 className="section-title text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-6 sm:mb-8">
          {c.title}
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-purple-200 mb-8 sm:mb-10 px-4">
          {c.intro}
        </p>

        <div className="modern-panel rounded-xl p-5 sm:p-6 mb-6 sm:mb-8">
          <p className="text-purple-300 text-xs uppercase tracking-[0.12em] font-bold mb-3">{c.email}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-white">
            <span className="text-base sm:text-lg font-semibold break-all">
              {CONTACT_EMAIL}
            </span>
            <button
              type="button"
              onClick={handleCopyEmail}
              className="secondary-button px-5 py-2 rounded-full text-sm sm:text-base font-semibold transition-all duration-300"
              aria-label={c.copyLabel}
            >
              {copied ? c.copied : c.copy}
            </button>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center mb-8 sm:mb-12">
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="primary-button w-full sm:w-auto px-6 sm:px-8 py-3 rounded-full font-semibold transform hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base"
          >
            {c.send}
          </a>
          <div className="flex gap-3 sm:gap-4 justify-center items-center">
            <a
              href="https://www.instagram.com/nuclearteam1/"
              className="secondary-button p-3 rounded-full text-white hover:text-pink-200 transform hover:-translate-y-0.5 transition-all duration-300"
              aria-label="Instagram"
            >
              <FaInstagram size={24} className="sm:w-8 sm:h-8" />
            </a>
            <a
              href={TIKTOK_URL}
              className="secondary-button p-3 rounded-full text-white hover:text-cyan-200 transform hover:-translate-y-0.5 transition-all duration-300"
              aria-label="TikTok"
            >
              <FaTiktok size={24} className="sm:w-8 sm:h-8" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
